import * as StoryletActionTypes from 'actiontypes/storylet';

export default function chooseBranchSuccess(data) {
  const {
    actions,
    phase,
    storylets,
    storylet,
    rename,
    endStorylet,
    socialAct,
    externalSocialAct,
    secondChance,
    messages,
  } = data;
  return {
    type: StoryletActionTypes.CHOOSE_BRANCH_SUCCESS,
    payload: {
      actions,
      phase,
      storylets,
      storylet,
      rename,
      endStorylet,
      socialAct,
      externalSocialAct,
      secondChance,
      messages,
      eligibleFriends: socialAct && socialAct.inviteeData.eligibleFriends,
    },
  };
}